export default __webpack_public_path__ + "static/media/About_BG-06.4208a5fb.svg";